import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function WeeklyRecapCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("weeklyRecapCard.title")}</h1>
      <p>{t("weeklyRecapCard.intro")}</p>

      <CodeBlock title="weeklyRecapImage()">{`import { weeklyRecapImage } from "kira-arts";

const buffer = await weeklyRecapImage(userId, {
  guildId,
  guildName: "kira-arts",
  messagesSent: 342,
  voiceMinutes: 187,
  xpGained: 1280,
  currentStreak: 6,
  rankChange: 3,
  mostActiveDay: "Friday",
  dailyActivity: [
    { label: "Mon", value: 40 },
    { label: "Tue", value: 62 },
    { label: "Wed", value: 35 },
    { label: "Thu", value: 80 },
    { label: "Fri", value: 120 },
    { label: "Sat", value: 55 },
    { label: "Sun", value: 20 },
  ],
});`}</CodeBlock>

      <h2>{t("weeklyRecapCard.optionsTitle")}</h2>
      <CodeBlock title="WeeklyRecapOptions">{`messagesSent?: number;
voiceMinutes?: number;
xpGained?: number;
currentStreak?: number;
rankChange?: number;
mostActiveDay?: string;
dailyActivity?: { label: string; value: number }[];
guildName?: string;
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
guildId?: string;
bypassCache?: boolean;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="weeklyRecapCard.chartNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="weeklyRecapCard.statsNote"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>
    </article>
  );
}
